//@ts-nocheck
import { BANK_ACCOUNT_TABLE_HEADER } from "./headers";
import DefaultCell from "layouts/ecommerce/orders/order-list/components/DefaultCell";
import MDButton from "../../../components/MDButton";
import { Delete, Refresh } from "@mui/icons-material";
import MDBox from "../../../components/MDBox";
import { Tooltip, IconButton } from "@mui/material";
import SwapVerticalCircleIcon from "@mui/icons-material/SwapVerticalCircle";

export interface AccountColumns {
  Header: string;
  accessor: string;
  width?: number;
  minWidth?: number;
  Cell?: any;
}

const isPlaidAccount = (account) => {
  return account.source === "Plaid";
};

const isFlinksAccount = (account) => {
  return account.source === "Flinks";
};

export const BANK_ACCOUNT_COLUMNS = (
  isReadOnly,
  handleDeleteStatement: (statementId: number, source: string, bankId?: number) => void,
  handleTransactionPullPopup: (value: boolean, account: any) => void,
  handlePlaidAccountRefresh: (account: any, isPlaid: boolean) => void,
  handleFlinksAccountRefresh: (account: any) => void,
  handleAllSelection: (allSelected: boolean) => void
) => [
  {
    Header: BANK_ACCOUNT_TABLE_HEADER.ACCOUNT_NUMBER,
    accessor: "accountnumber",
    minWidth: 180,
    allowSelection: true,
    Cell: ({ value, row }) => {
      const account = row.original;
      return (
        <MDBox display={"flex"} alignItems={"center"}>
          <DefaultCell value={value} />
          {isPlaidAccount(account) && (
            <Tooltip title="Pull Transactions" arrow>
              <IconButton
                disabled={isReadOnly}
                sx={{ color: "#80C4D0" }}
                onClick={() => handleTransactionPullPopup(true, account)}
              >
                <SwapVerticalCircleIcon />
              </IconButton>
            </Tooltip>
          )}
        </MDBox>
      );
    },
  },
  {
    Header: BANK_ACCOUNT_TABLE_HEADER.MONTH,
    accessor: "monthyear",
    minWidth: 80,
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: BANK_ACCOUNT_TABLE_HEADER.BANK_NAME,
    accessor: "accountname",
    minWidth: 80,
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: BANK_ACCOUNT_TABLE_HEADER.SOURCE,
    accessor: "source",
    minWidth: 100,
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: "Actions",
    accessor: "actions",
    minWidth: 120,
    Cell: ({ row }: any) => {
      const accountSrc = row?.original?.source?.toString().trim().toLowerCase();
      const handleDelete = () => {
        const statementId = row.original.statementid;
        const source = row.original.source;
        const bankId = row.original.bankId;
        handleDeleteStatement(statementId, source, bankId);
      };

      const handleRefresh = () => {
        const account = row.original;
        handlePlaidAccountRefresh(account, false);
      };

      const handleFlinksRefresh = () => {
        const account = row.original;
        handleFlinksAccountRefresh(account);
      };

      return (
        <MDBox display={"flex"} justifyContent={"flex-start"}>
          {isPlaidAccount(row.original) && (
            <MDButton
              variant="text"
              color="primary"
              onClick={handleRefresh}
              startIcon={<Refresh />}
              disabled={isReadOnly}
            >
              Refresh
            </MDButton>
          )}

          {isFlinksAccount(row.original) && (
            <MDButton
              variant="text"
              color="primary"
              onClick={handleFlinksRefresh}
              startIcon={<Refresh />}
              disabled={isReadOnly}
            >
              Refresh
            </MDButton>
          )}

         { (accountSrc !=='ocrolus') &&
          <MDButton
            variant="text"
            color="error"
            onClick={handleDelete}
            startIcon={<Delete />}
            disabled={isReadOnly}
          >
            Delete
          </MDButton>
           }
        </MDBox>
      );
    },
  },
];
